import Image from "next/image";
import React from "react";

function ArrowButton({ children, className, ...props }: ArrowButtonPropsType) {
  return (
    <button
      type="button"
      className={`relative  group hover:opacity-90  inline-flex items-center 
       text-white  hover:sh font-medium lg:rounded-[20px] rounded-[16px] text-[14px] lg:text-[1.25rem]
       min-h-[48px] min-w-[48px] lg:min-h-[56px] lg:min-w-[56px]
       px-[4.4rem] py-[0.87rem] focus:outline-none  ${className}`}
      {...props}
    >
      <span> {children}</span>
      <Image
        width={11.6}
        height={11.6}
        className={`absolute rotate-90 rtl:rotate-[-90deg] end-[6.25rem] group-hover:end-[2.93rem] w-0 group-hover:w-[1.1rem]   transition-all   ease-in-out duration-300 `}
        src="/icons/arrowTop.svg"
        alt="Arrow icon for button"
      />
    </button>
  );
}

export default ArrowButton;
type ArrowButtonPropsType = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;
